import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { View } from "../../../../components/layout/View";
import { PageType } from "../../../../config/page.types";
import { useBreadcrumbs } from "../../../../context/BreadcrumbsProvider";
import SupersetDashboard from "./components/SupersetDashboard";

const ResultsDashboardInsightsDetail = () => {
	const { visitPage } = useBreadcrumbs();

	const params = useParams();
	const dashboardId = params.id as string;

	useEffect(() => {
		if (dashboardId) {
			visitPage(PageType.ResultsDashboardInsightsDetail, false, dashboardId);
		}
	}, [dashboardId, visitPage]);

	return (
		<View pageType={PageType.ResultsDashboardInsightsDetail}>
			<SupersetDashboard dashboardId={dashboardId} />
		</View>
	);
};

export default ResultsDashboardInsightsDetail;
